<template>
  <div class="panel-body">
    <div class="panel-body-checkbox">
      <div class="panel-body-checkbox-item">
        <v-checkbox hide-details
                    :input-value="optionsCount === 1"
                    @click="(evt) => checkBoxClick({evt, box: 1})"></v-checkbox>
        <span class="text">{{$t('message.campaigns.message.oneButton')}}</span>
      </div>
      <div class="panel-body-checkbox-item">
        <v-checkbox hide-details
                    :input-value="optionsCount === 2"
                    @click="(evt) => checkBoxClick({evt, box: 2})"></v-checkbox>
        <span class="text">{{$t('message.campaigns.message.twoButtons')}}</span>
      </div>
    </div>

    <div class="border-bottom">
      <app-option-editor :data-title="$t('message.campaigns.message.button1')"
                        :data-max-length="maxLength"
                        :data-interaction="interactionStored"
                        :data-option="interactionStored.opcoes[0]"
                        :eyedropper="false"
                        @change="(evt) => $emit('update-option', {option: interactionStored.opcoes[0], data: {nome: evt}})"
                        @change-auth="(evt) => $emit('update-option', {option: interactionStored.opcoes[0], data: {paginaPosAutenticacao: evt}})"
                        @reload="emitReload">
      </app-option-editor>
    </div>

    <div class="border-bottom"
        v-if="interactionStored.opcoes.length > 1">
      <app-option-editor :data-title="$t('message.campaigns.message.button2')"
                        :data-max-length="maxLength"
                        :data-interaction="interactionStored"
                        :data-option="interactionStored.opcoes[1]"
                        :eyedropper="false"
                        @change="(evt) => $emit('update-option', {option: interactionStored.opcoes[1], data: {nome: evt}})"
                        @change-auth="(evt) => $emit('update-option', {option: interactionStored.opcoes[1], data: {paginaPosAutenticacao: evt}})"
                        @reload="emitReload">
      </app-option-editor>
    </div>

    <app-form @submit="emitForm"
              class="panel-body-form border-bottom"
              ref="form">
      <div><strong>Dados do anúncio</strong></div>

      <div class="panel-body-tag">
          <h6>Google Tag</h6>
          <text-field class="panel-body-tag-input"
                      :label="$t('message.campaigns.message.text')"
                      v-model="form.googleTag"
                      validate="required"
                      name="Google Tag"
                      @change="(evt) => $emit('update', {googleTag: evt})"></text-field>
      </div>

      <div class="panel-body-size">
          <h6>Tamanho aceito</h6>

          <div class="panel-body-size-inputs">
              <text-field label="Largura"
                          v-model="form.sizeVal.width"
                          type="number"></text-field>
              <text-field label="Altura"
                          v-model="form.sizeVal.height"
                          type="number"></text-field>
          </div>
      </div>

      <div class="panel-body-form-submit">
        <app-button
          class="btn btn-primary btn-round"
          type="submit"
          label="Salvar"
          small
          primary>
        </app-button>
      </div>
    </app-form>
  </div>
</template>

<script>
    import AppButton from "@components/generic/button/Button.vue";
    import EventBus from "@packages/event-bus";
    import TextField from "@components/form/TextField.vue";
    import AppForm from "@components/form/Form.vue";
    import AppOptionEditor from '../../OptionEditor'
    import panelBody from '../../../mixins/panel-body'
    import _ from 'lodash'

    export default {
        components: {
          AppOptionEditor,
          AppForm,
          TextField,
          AppButton
        },

        data() {
          return {
            hasBackgroundColor: false,
            form: {
              googleTag: undefined,
              sizeVal: {
                width: undefined,
                height: undefined
              },
            }
          }
        },

        computed: {
          maxLength() {
            return this.interactionStored.opcoes.length === 1 ? 22 : 12
          },
        },

        mounted() {
          this.form.googleTag = this.dataInteraction.googleTag;
          if(this.dataInteraction.googleTagSize) {
            this.setInitialGPTSize();
          }
        },

        methods: {
          setInitialGPTSize() {
            const sizesArray = JSON.parse(this.dataInteraction.googleTagSize);

            this.form.sizeVal = {
              width: sizesArray[0],
              height: sizesArray[1]
            };
          },
          validateForm() {
            if(this.form.sizeVal.height) {
              if(this.form.sizeVal.height > 3000) {
                EventBus.$emit("show-message", {
                  type: "ERROR",
                  message: 'A altura máxima é 3.000',
                });
                return false;
              }

              if(!this.form.sizeVal.width) {
                EventBus.$emit("show-message", {
                  type: "ERROR",
                  message: 'É necessário informar a largura',
                });
                return false;
              }
            }
            if(this.form.sizeVal.width) {
              if(this.form.sizeVal.width > 3000) {
                EventBus.$emit("show-message", {
                  type: "ERROR",
                  message: 'A largura máxima é 3.000',
                });
                return false;
              }
              if(!this.form.sizeVal.height) {
                EventBus.$emit("show-message", {
                  type: "ERROR",
                  message: 'É necessário informar a altura',
                });
                return false;
              }
            }
            if(this.form.googleTag && this.form.googleTag.length > 256) {
              EventBus.$emit("show-message", {
                type: "ERROR",
                message: 'O tamanho maximo da tag é 256 caracteres',
              });
              return false;
            }

            return true;
          },
          emitForm() {
            const isValid = this.validateForm();

            if(!isValid) {
              return;
            }

            const emitVal = {
              googleTag: this.form.googleTag
            }

            if(this.form.sizeVal.height && this.form.sizeVal.width) {
              emitVal.googleTagSize = `[${this.form.sizeVal.width}, ${this.form.sizeVal.height}]`;
            }

            this.$emit('update', emitVal)
          },
          checkBoxClick({evt, box}) {
            evt.preventDefault()
            evt.stopPropagation()

            if (box === 2 && (this.optionsCount === 1 || this.optionsCount === 0))
                this.$emit('add-option')

            const lastOption = _.maxBy(this.interactionStored.opcoes, (option) => {
                return option.ordem
            })

            if (box === 1 && this.optionsCount === 2)
                this.$emit('remove-option', lastOption)
            },
            emitReload() {
              this.$emit('reload')
            },
        },

        mixins: [panelBody],
    }
</script>

<style lang="scss" scoped>
@import "../../../mixins/panel-body";

.panel-body {
  .panel-body-checkbox {
    display: flex;
    justify-content: space-between;
    padding: 10px 30px;
    font-size: 14px;
    font-weight: bold;

    .panel-body-checkbox-item {
      display: flex;
      align-items: center;
      justify-content: flex-start;

      .text {
        margin: 4px 0 0 -6px;
      }
    }
  }

  .panel-body-tag {
    padding-bottom: 0;
  }



  .panel-body-form {
    > * {
      margin-bottom: 15px;
    }

      .panel-body-size {
        padding-bottom: 0;
        margin-bottom: 0;

        .panel-body-size-inputs {
          display: flex;
          gap: 20px;
        }
      }

    .panel-body-form-submit {
      display: flex;
      justify-content: center;
      margin-bottom: 0;

      .button {
        width: 100%;
      }
    }
  }
}
</style>
